export default {
  name: 'marking--orderGetKM',
  apiService: 'shoes',
  apiPath: '/admin/order/func/km_from_order',
  urlParamName: 'marking--orderGetKM',
};